import React from 'react'
import createReactClass from 'create-react-class'
import CloudwaysFooter from './cloudways/cloudwaysfooter'

//XNOTE: Currently Not using but should be used if footer is needed in different origin form
const Footer = createReactClass({
	render() {
		const { migrate } = this.props
		switch (migrate.get('origin')) {
		default:
			return null
		}
	}
})

export default Footer
